import gql from 'graphql-tag';

export default gql`
  mutation ScanPlate($image: Upload!, $imageContext: String) {
    dailyTracker {
      scanPlate(image: $image, imageContext: $imageContext) {
        __typename
        ... on ScanPlateSuccess {
          mealName
          requestId
          portions
          ingredients {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            carbsGrams
            fatGrams
            measurement {
              measureId
              amount
              unit
              text
            }
          }
          imageUrl
        }
        ... on NotFoodError {
          message
          description
        }
        ... on AiAccessDenied {
          accessDeniedMessage: message
          accessDeniedDescription: description
        }
        ... on RateLimitExceeded {
          rateLimitExceededMessage: message
          rateLimitExceededDescription: description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
